import { STATUS_META, STATUS_ORDER } from "@/lib/pipeline";
import { RotateCcw, X } from "lucide-react";

const inputCls = "w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm outline-none focus:border-violet-500";

export function FilterPanel({ f, setF, areas, statusCounts, positionOptions, onClear, onClose }) {
  const toggle = (s) => setF({ statuses: f.statuses.includes(s) ? f.statuses.filter((x) => x !== s) : [...f.statuses, s] });
  return (
    <div className="mt-3 rounded-3xl bg-white border border-slate-200 shadow-lg p-5 animate-in fade-in slide-in-from-top-1" data-testid="filter-panel">
      <div className="flex items-center justify-between">
        <div className="font-head font-semibold text-[#1e2a5a]">Filtre</div>
        <button data-testid="filter-panel-close" onClick={onClose} className="text-slate-400 hover:text-slate-700"><X size={18} /></button>
      </div>
      <div className="mt-4 grid gap-5 md:grid-cols-2 xl:grid-cols-4">
        <div>
          <Label>Pracovná oblasť</Label>
          <select data-testid="filter-area" value={f.area} onChange={(e) => setF({ area: e.target.value, position: "" })} className={inputCls}>
            <option value="all">Všetky oblasti</option>
            {areas.map((a) => <option key={a.area} value={a.area}>{a.area} ({a.count})</option>)}
          </select>
          <Label className="mt-4">Pozícia</Label>
          <select data-testid="filter-position" value={f.position} onChange={(e) => setF({ position: e.target.value })} className={inputCls}>
            <option value="">Všetky pozície</option>
            {positionOptions.map((p) => <option key={p} value={p}>{p}</option>)}
          </select>
        </div>
        <div>
          <Label>Stav kandidáta</Label>
          {STATUS_ORDER.map((s) => (
            <label key={s} className="flex items-center gap-2 py-0.5 text-sm cursor-pointer">
              <input type="checkbox" data-testid={`filter-status-${s}`} checked={f.statuses.includes(s)} onChange={() => toggle(s)} className="accent-violet-600" />
              <span className={`h-2 w-2 rounded-full ${STATUS_META[s].dot}`} /> <span className="flex-1 text-slate-700">{STATUS_META[s].l}</span>
              <span className="text-xs text-slate-400">{statusCounts[s] || 0}</span>
            </label>
          ))}
        </div>
        <div>
          <Label>Zručnosti</Label>
          <input data-testid="filter-skills" value={f.skill} onChange={(e) => setF({ skill: e.target.value })} placeholder="napr. Java" className={inputCls} />
          <Label className="mt-4">Lokácia</Label>
          <input data-testid="filter-location" value={f.location} onChange={(e) => setF({ location: e.target.value })} placeholder="napr. Bratislava" className={inputCls} />
        </div>
        <div>
          <Label>Dátum pridania od</Label>
          <input type="date" data-testid="filter-date-from" value={f.from} onChange={(e) => setF({ from: e.target.value })} className={inputCls} />
          <button data-testid="filter-clear" onClick={onClear} className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-violet-700 hover:underline"><RotateCcw size={14} /> Vymazať filtre</button>
        </div>
      </div>
    </div>
  );
}

const Label = ({ children, className = "" }) => <div className={`mb-2 text-xs font-bold uppercase tracking-wide text-slate-400 ${className}`}>{children}</div>;
